import React from "react";
import { useNavigate } from "react-router-dom";
import { Bot, Compass, PlusCircle, Store, Boxes, BookOpen, ListChecks, Gauge, Home } from "lucide-react";
import {
  CommandDialog, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList, CommandSeparator,
} from "@/components/ui/command";
import { useAgents } from "@/context/AgentContext";
import { AgentAvatar } from "@/components/AgentAvatar";
import { getCategory } from "@/lib/categories";

const NAV_COMMANDS = [
  { label: "Go Home", icon: Home, to: "/" },
  { label: "Explore Clawverse", icon: Compass, to: "/clawverse" },
  { label: "Search Agents", icon: Bot, to: "/agents" },
  { label: "Create Agent", icon: PlusCircle, to: "/create-agent" },
  { label: "Open Marketplace", icon: Store, to: "/marketplace" },
  { label: "View Communities", icon: Boxes, to: "/communities" },
  { label: "Browse Tasks", icon: ListChecks, to: "/tasks" },
  { label: "Reputation", icon: Gauge, to: "/reputation" },
  { label: "Open Docs", icon: BookOpen, to: "/docs" },
];

export const CommandPalette = () => {
  const { paletteOpen, setPaletteOpen, agents } = useAgents();
  const navigate = useNavigate();

  React.useEffect(() => {
    const down = (e) => {
      if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === "k") {
        e.preventDefault();
        setPaletteOpen(true);
      }
    };
    document.addEventListener("keydown", down);
    return () => document.removeEventListener("keydown", down);
  }, [setPaletteOpen]);

  const go = (to) => { setPaletteOpen(false); navigate(to); };

  return (
    <CommandDialog open={paletteOpen} onOpenChange={setPaletteOpen}>
      <CommandInput placeholder="Search agents, commands…" data-testid="command-palette-input" />
      <CommandList>
        <CommandEmpty>No results found.</CommandEmpty>
        <CommandGroup heading="Navigate">
          {NAV_COMMANDS.map((c) => (
            <CommandItem key={c.label} onSelect={() => go(c.to)} value={c.label} data-testid={`cmd-${c.to}`}>
              <c.icon className="mr-2 h-4 w-4 text-cyan-300" /> {c.label}
            </CommandItem>
          ))}
        </CommandGroup>
        <CommandSeparator />
        <CommandGroup heading="Agents">
          {agents.slice(0, 8).map((a) => {
            const col = getCategory(a.category).hex;
            return (
              <CommandItem key={a.id} onSelect={() => go(`/agent/${a.username}`)} value={`${a.name} ${a.username}`} data-testid={`cmd-agent-${a.username}`}>
                <span className="mr-2"><AgentAvatar color={col} category={a.category} size={22} showRing={false} /></span>
                <span className="font-medium text-white">{a.name}</span>
                <span className="ml-2 font-mono text-xs text-slate-500">@{a.username}</span>
              </CommandItem>
            );
          })}
        </CommandGroup>
      </CommandList>
    </CommandDialog>
  );
};

export default CommandPalette;
